<template>
  <div class="wrapper">
    <template v-if="content">
      <div class="container" v-html="content" @click="handleLinkClick"></div>
    </template>
    <safe-area-bottom />
  </div>
</template>

<script>
import QueryString from "query-string"
import Axios from "axios"
import SafeAreaBottom from "@/components/safe-area/safe-area-bottom.vue"
import { externalLinkHandlerMixin } from "@/utils/external-link-handler.js"

export default {
  mixins: [externalLinkHandlerMixin],

  components: {
    SafeAreaBottom
  },

  data() {
    return {
      content: ""
    }
  },

  created() {
    const { id } = QueryString.parse(window.location.search)
    this.fetchContent(id)
  },

  methods: {
    async fetchContent(id) {
      const apiLatest = "/aries-profile/api/protocol/type/user_privacy/present"
      const apiDetail = `/aries-profile/api/protocol/type/user_privacy/${id}`
      const tagetURL = /^[0-9]+$/gi.test(id) ? apiDetail : apiLatest

      try {
        const { data } = await Axios.get(tagetURL).then((res) => res.data)
        const { html, style } = data.content

        // append head.style
        const styleELement = document.createElement("style")
        styleELement.innerHTML = style
        window.document.head.appendChild(styleELement)

        // append dom
        this.content = html
          .replaceAll("猿力教育", "星奔川鹜")
          .replaceAll("猿力科技", "星奔川鹜")
          .replaceAll("光而不耀", "星奔川鹜")
      } catch (error) {
        console.warn(error)

        this.$toast({
          type: "fail",
          message: "协议加载失败"
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.container
  padding 15px 12.5px
  background #ffffff
  margin 0
  text-align justify
  color #4d4d4d
</style>
